import { Pipe, PipeTransform } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';


@Pipe({ name: 'onlyJoined' })
export class OnlyJoinedGroupPipe implements PipeTransform {
    constructor(private apiservice: ApiService) { }

    transform(items: any[], filter: Object): any {
        if (!items) {
            return items;
        }

        return items.filter(item => {
            let index = item.subscribers.findIndex(data => data._id == this.apiservice.user._id);
            if (index >= 0) {
                return true;
            }
            return false;
        });
    }
}